interface SelectOption {
  label: string;
  value: string;
}

export const formatSelectedOptionLabels = (
  options: SelectOption[],
  selectedIds: string[],
  emptyLabel: string,
): string => {
  if (selectedIds.length === 0) return emptyLabel;

  const selectedIdSet = new Set(selectedIds);
  const optionIds = new Set(options.map(option => option.value));
  const selectedOptionLabels = options
    .filter(option => selectedIdSet.has(option.value))
    .map(option => option.label || option.value);
  const unknownOptionLabels = selectedIds.filter(id => !optionIds.has(id));

  return [...selectedOptionLabels, ...unknownOptionLabels].join(', ');
};

export const formatSelectedProgramScope = (
  programOptions: SelectOption[],
  selectedProgramIds: string[],
): string => formatSelectedOptionLabels(programOptions, selectedProgramIds, 'All programs');
